import type { RefObject } from 'react';
import { useEffect, useState } from 'react';

export const useStuck = (slotRef: RefObject<HTMLElement | null>) => {
  const [stuck, setStuck] = useState(false);

  useEffect(() => {
    const slot = slotRef.current;
    if (!slot) return;
    const io = new IntersectionObserver(
      ([entry]) => {
        setStuck(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      },
      { rootMargin: '-15px 0px 0px 0px' }
    );
    io.observe(slot);
    return () => io.disconnect();
  }, [slotRef]);

  return stuck;
};
